import MarketBase from './market-base';
import MarketDateTimeRange from './market-date-time-range';

export default class MarketSchedule extends MarketBase{
    AllowedDateTimeRange: Array<MarketDateTimeRange> = [];
    CurrentState: number = 0;
    FirstOccurence: string = "";
    Flatten: boolean = false;
}